module.exports = "pegasus/assets/tech/large/1.jpg";